// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__Y5fdg","checkbox":"checkbox_checkbox__nfgAd","label":"checkbox_label__5tzAN","suffix":"checkbox_suffix__LS29G"};